// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e2ebb11","239":"ebca7337","453":"23033a9b","667":"2fbb09bc"}[chunkId] + ".chunk.js";
};